import { Tenant } from "../../data/models.interface"
import useQuery from "../useQuery"

export const useGetTenantQuery = (tenantId: string) => {
	const url = `${process.env.REACT_APP_ACCESS_CONTROL_BACK_URL}/tenants/${tenantId}`
	const { query, data, loading, error } = useQuery<void, Tenant>(url)
	const invalidIdError = !loading && data == null ? "No Tenant found" : undefined
	const tenantError = error || invalidIdError
	return { query, data, loading, error: tenantError }
}
